<template>
  <div class="entry-controls">
    <Button
      v-if="entry.comment"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Посмотреть комментарий',
        placement: 'top',
      }"
      size="iconic"
      icon="comment"
      @click="emitAction('showComment')"
    />
    <Button
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Посмотреть описание',
        placement: 'top',
      }"
      :disabled="!entry.item.id"
      size="iconic"
      icon="file"
      @click="emitAction('showInfo')"
    />
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

export default {
  name: "history-entry-contols",
  components: {
    Button,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitAction (action) {
      this.$emit(action, this.entry);
    },
  },
};
</script>

<style lang="scss" scoped>
.entry-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 4px;
  gap: 7px;
}
</style>